/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backup_User_Settings_DescInputs */



/**
* | output |
* | --- |
* | "Backup user settings" |
*
* @param {Backup_User_Settings_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const backup_user_settings_desc = /** @type {((inputs?: Backup_User_Settings_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backup_User_Settings_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarder les paramètres utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzereinstellungen sichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Backup delle impostazioni utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Резервное копирование пользовательских настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copia de seguridad de la configuración del usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("备份用户设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー設定のバックアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता सेटिंग्स का बैकअप लें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fazer backup das configurações do usuário")
	return /** @type {LocalizedString} */ ("Backup user settings")
});